/* eslint-disable @typescript-eslint/no-explicit-any */
import ComboBoxFormik from "@/common/components/form/ComboBoxFormik";

interface Props {
  formik: any;
  rules: any;
  entryPercentageOptions: { value: string; label: string }[];
  installmentOptions: { value: string; label: string }[];
  currentFees: any;
  baseValue: number;
}

export default function CreditCardPayment({
  formik,
  rules,
  entryPercentageOptions,
  installmentOptions,
}: Props) {
  return (
    <>
      {entryPercentageOptions.length > 0 && (
        <ComboBoxFormik
          label="Entrada (opcional)"
          name="creditCard.entryPercentage"
          options={entryPercentageOptions}
          placeholder="Sem entrada"
          onChange={(value) => {
            formik.setFieldValue('creditCard.entryPercentage', String(value));
          }}
        />
      )}

      {rules.canInstallment && (
        <ComboBoxFormik
          label="Parcelas no cartão"
          name="creditCard.installments"
          options={installmentOptions}
          placeholder="Parcelas"
          disabled={String(formik.values.creditCard.entryPercentage) === '100'}
          onChange={(value) => {
            formik.setFieldValue('creditCard.installments', parseFloat(String(value)) || 1);
          }}
        />
      )}

      {/* Se quiser manter inputs específicos do cartão (ex: data) adicione aqui */}
    </>
  );
}
// ...existing code...